import {getCreditsForPAYGUser} from '@Libraries/user.library';
import type {PAYGUserCreditsProps} from '@Components/payg-user-credits/payg-user-credits-slice';
import {updateIsLoading} from '@Components/payg-user-credits/payg-user-credits-slice';
import {initPAYGUserCredits} from '@Components/payg-user-credits/payg-user-credits-slice';

export const getPAYGUserCredits = async (): Promise<PAYGUserCreditsProps> => {
  let credits = getPAYGUserCreditsFromStore();
  if (credits.isBGRAllowed !== null && credits.imageBGRCredits !== null && credits.videoBGRCredits !== null) {
    return credits;
  }

  if (credits.isLoading) {
    return credits;
  }

  window.PMW.redux.store.dispatch(updateIsLoading(true));
  const creditsResponse = await getCreditsForPAYGUser();
  if (creditsResponse !== null) {
    credits = creditsResponse;
    window.PMW.redux.store.dispatch(initPAYGUserCredits(creditsResponse));
  }
  return credits;
};

export const getPAYGUserCreditsFromStore = (): PAYGUserCreditsProps => {
  return window.PMW.redux.store.getState().paygUserCredits;
};
